// extracted by mini-css-extract-plugin
export default {"container":"AccountPage_container__lpgSg","cardDimensions":"AccountPage_cardDimensions__oP0uB","cardStrech":"AccountPage_cardStrech__ypIA9"};